import { useSelector } from 'react-redux';
import { getReferrerUserInfo } from '../selectors';

export const useUserReferrerInfo = () => ({
  referrerInfo: useSelector(getReferrerUserInfo),
});
